export const getWrittenPrice = (valor: number): string => {
  const unidades = [
    "",
    "um",
    "dois",
    "três",
    "quatro",
    "cinco",
    "seis",
    "sete",
    "oito",
    "nove",
  ];
  const especiais = [
    "dez",
    "onze",
    "doze",
    "treze",
    "quatorze",
    "quinze",
    "dezesseis",
    "dezessete",
    "dezoito",
    "dezenove",
  ];
  const dezenas = [
    "",
    "",
    "vinte",
    "trinta",
    "quarenta",
    "cinquenta",
    "sessenta",
    "setenta",
    "oitenta",
    "noventa",
  ];
  const centenas = [
    "",
    "cento",
    "duzentos",
    "trezentos",
    "quatrocentos",
    "quinhentos",
    "seiscentos",
    "setecentos",
    "oitocentos",
    "novecentos",
  ];

  function lerCentena(n: number): string {
    if (n === 0) return "";
    if (n === 100) return "cem";

    const c = Math.floor(n / 100);
    const d = Math.floor((n % 100) / 10);
    const u = n % 10;

    let partes: string[] = [];

    if (c > 0) partes.push(centenas[c]);
    if (d === 1) {
      partes.push(especiais[u]);
    } else {
      if (d > 1) partes.push(dezenas[d]);
      if (u > 0) partes.push(unidades[u]);
    }

    return partes.join(" e ");
  }

  function numeroParaExtenso(n: number): string {
    if (n === 0) return "zero";

    let partes: string[] = [];

    const milhoes = Math.floor(n / 1_000_000);
    if (milhoes > 0) {
      partes.push(
        milhoes === 1 ? "um milhão" : `${numeroParaExtenso(milhoes)} milhões`
      );
      n %= 1_000_000;
    }

    const mil = Math.floor(n / 1000);
    if (mil > 0) {
      if (mil === 1) {
        partes.push("mil");
      } else {
        partes.push(`${numeroParaExtenso(mil)} mil`);
      }
      n %= 1000;
    }

    if (n > 0) {
      if (partes.length > 0) partes.push("e");
      partes.push(lerCentena(n));
    }

    return partes.join(" ");
  }

  const inteiro = Math.floor(valor);
  const centavos = Math.round((valor - inteiro) * 100);

  const reaisExtenso = numeroParaExtenso(inteiro);
  const centavosExtenso = numeroParaExtenso(centavos);

  const parteReais =
    inteiro === 0 ? "" : inteiro === 1 ? "um real" : `${reaisExtenso} reais`;

  const parteCentavos =
    centavos === 0
      ? ""
      : centavos === 1
      ? "um centavo"
      : `${centavosExtenso} centavos`;

  if (typeof valor !== "number" || isNaN(valor))
    return "valor numérico inválido";
  if (parteReais && parteCentavos) return `${parteReais} e ${parteCentavos}`;
  if (parteReais) return parteReais;
  if (parteCentavos) return parteCentavos;

  return "zero real"; // caso 0.00
};
